import { AppTeamUtil } from '../../core/app-team-util';
import { MyCampApp } from '../common/enumerations';
import LogEntryActionType = MyCampApp.LogEntryActionType;

export class GlobalAdminReportUserInfo
{
	FirstName!: string;
	LastName!: string;
	Email!: string;
	UserId!: string;

	constructor(json?: any)
	{
		Object.assign(this, json);
	}

	public get fullName(): string { return `${this.FirstName} ${this.LastName}`; }
}

export class GlobalAdminReportEntry
{
	Date!: Date;
	UserId!: string;
	Action!: LogEntryActionType;
	Notes!: string;
	constructor(json?: any)
	{
		Object.assign(this, json);

		this.Date = AppTeamUtil.convertApiDateStringToDate(json['Date'])!;
	}
}

export class GlobalAdminReportData
{
	Admins!: GlobalAdminReportUserInfo[];
	Data!: GlobalAdminReportEntry[];

	constructor(json?: any)
	{
		this.Admins = json.Admins.map((itemJson: any) => new GlobalAdminReportUserInfo(itemJson));
		this.Data = json.Data.map((itemJson: any) => new GlobalAdminReportEntry(itemJson));
	}
}
